import { useState } from 'react';

import type { HandleClickLikeParams } from '../../types';
import { MatchMessage } from './match-message';
import { ReceivedLikeButtonGroup } from './received-like-button-group';
import { SendLikeButtonGroup } from './send-like-button-group';
import { SentLikeButtonGroup } from './sent-like-button-group';

type Props = {
  company: {
    name: string;
    id: number;
  };
  jobDescription: {
    id: number;
    jdHash: string;
  };
  jobDescriptionLike:
    | {
        likeHash: string;
        likeExpirationDate: string;
      }
    | null
    | undefined;
  matchHash: string;
  isBlockCompany: boolean;
  isKeep: boolean;
  isSent: boolean;
  isUserSuccessCommitmentJobInterview: boolean;
  hasMatch: boolean;
  hasReceivedLike: boolean;
  onClickLike?: (params: HandleClickLikeParams) => void;
  onClickKeep?: (likeHash: string, isKeep: boolean) => void;
};

export const LikeButtonGroup = ({
  company,
  jobDescription,
  jobDescriptionLike,
  matchHash,
  isBlockCompany,
  isKeep,
  isSent,
  isUserSuccessCommitmentJobInterview,
  hasMatch,
  hasReceivedLike,
  onClickLike,
  onClickKeep,
}: Props) => {
  const [isOpenFixedContents, setIsOpenFixedContents] = useState(true);

  // マッチした場合
  if (hasMatch)
    return <MatchMessage companyName={company.name} matchHash={matchHash} />;

  // いいかもを送った場合
  if (isSent)
    return (
      <SentLikeButtonGroup
        companyName={company.name}
        isOpen={isOpenFixedContents}
        onClose={() => setIsOpenFixedContents(!isOpenFixedContents)}
      />
    );

  // いいねを受け取っている場合
  if (hasReceivedLike) {
    return (
      <ReceivedLikeButtonGroup
        companyName={company.name}
        isBlockCompany={isBlockCompany}
        isKeep={isKeep}
        isOpen={isOpenFixedContents}
        isUserSuccessCommitmentJobInterview={
          isUserSuccessCommitmentJobInterview
        }
        jobDescription={jobDescription}
        jobDescriptionLike={jobDescriptionLike}
        onClickKeep={onClickKeep}
        onClickLike={onClickLike}
        onClose={() => setIsOpenFixedContents(!isOpenFixedContents)}
      />
    );
  }

  return (
    <SendLikeButtonGroup
      isBlockCompany={isBlockCompany}
      isOpen={isOpenFixedContents}
      jobDescription={jobDescription}
      onClickLike={onClickLike}
      onClose={() => setIsOpenFixedContents(!isOpenFixedContents)}
    />
  );
};
